export enum StorePickerType {
    // Only lists stores to view stock, no select functionality
    INFO = "INFO",
    // Lists stores and allows to choose one
    SELECT = "SELECT",
    // Storepicker controlled by parent component by providing possible stores
    CUSTOM = "CUSTOM",
}
